import { AUTH_TOKEN_NAME } from '../config/consts';

const TOKEN_KEY = "erp";

const getAllCookies = () => {
  const pairs = document.cookie.split(";");
  let cookies = {};
  for (let i = 0; i < pairs.length; i++) {
    let pair = pairs[i].split("=");
    cookies[(pair[0] + "").trim()] = unescape(pair[1]);
  }
  return cookies;
};

const setCookie = (cname, cvalue, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 9 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  window.name = JSON.stringify(getAllCookies());
};

const getCookie = (cname) => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export default class Storage {
  /**
   * Getter function to set auth-token in sessionStorage.
   *
   * @param token
   */
  static set token(token) {
    setCookie(TOKEN_KEY, token, 1);
  }

  /**
   * Getter function to get auth-token from sessionStorage.
   *
   * @returns {string}
   */
  static get token() {
    return getCookie(TOKEN_KEY);
  }

  /**
   * Read a cookie value by key.
   *
   * @param {string} key
   * @returns {string}
   */
  static getCookie(key) {
    return getCookie(key);
  }

  /**
   * Store a string value in browser sessionStorage.
   *
   * @param {string} key
   * @param {string} value
   */
  static setItem(key, value) {
    sessionStorage.setItem(key, value);
  }

  /**
   * Read a string value from browser sessionStorage.
   *
   * @param {string} key
   * @returns {string | null}
   */
  static getItem(key) {
    return sessionStorage.getItem(key);
  }

  /**
   * Store an object in browser sessionStorage.
   *
   * @param {string}key
   * @param {object}object
   */
  static setObject(key, object) {
    sessionStorage.setItem(key, JSON.stringify(object));
  }

  /**
   * Get an object from browser sessionStorage.
   *
   * @param {string}item
   * @returns {any}
   */
  static getObject(item) {
    return JSON.parse(
      sessionStorage.getItem(item) !== null ? sessionStorage.getItem(item) : '{}'
    );
  }

  /**
   * Delete an object from browser sessionStorage.
   *
   * @param {string}key
   */
  static remove(key) {
    if (key === AUTH_TOKEN_NAME) {
      deleteCookie(TOKEN_KEY);
    } else {
      sessionStorage.removeItem(key);
    }
  }

  /**
   * Set flash message into browser sessionStorage.
   *
   * @param {string}messageKey
   * @param {string}message
   */
  static setFlash(messageKey, message) {
    sessionStorage.removeItem(messageKey);
    sessionStorage.setItem(messageKey, message);
  }

  /**
   *  Check if browser sessionStorage has a key with messageKey.
   *
   * @param {string}messageKey
   * @returns {boolean}
   */
  static hasFlash(messageKey) {
    return !!sessionStorage.getItem(messageKey);
  }

  /**
   * Get a flash message from browser sessionStorage.
   *
   * @param {string}messageKey
   */
  static getFlash(messageKey) {
    const message = sessionStorage.getItem(messageKey);
    sessionStorage.removeItem(messageKey);
    return message;
  }

  /**
   * Delete a cookie value by key.
   *
   * @param {string} key
   */
  static removeCookie(key) {
    deleteCookie(key);
  }
}
